/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inventory_Products_DescriptionInputs */

const en_inventory_products_description = /** @type {(inputs: Inventory_Products_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product catalog with filtering and sorting.`)
};

const es_inventory_products_description = /** @type {(inputs: Inventory_Products_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catalogo de productos con filtros y ordenamiento.`)
};

/**
* | output |
* | --- |
* | "Product catalog with filtering and sorting." |
*
* @param {Inventory_Products_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_products_description = /** @type {((inputs?: Inventory_Products_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Products_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_products_description(inputs)
	return es_inventory_products_description(inputs)
});